'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '../ui/AppImage';

interface NavigationItem {
  label: string;
  anchor: string;
}

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');
  const [isScrolled, setIsScrolled] = useState(false);

  const navigationItems: NavigationItem[] = [
    { label: 'Inicio', anchor: '#inicio' },
    { label: 'Servicios', anchor: '#servicios' },
    { label: 'Metodología', anchor: '#metodologia' },
    { label: 'Beneficios', anchor: '#beneficios' },
    { label: 'Contacto', anchor: '#contacto' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);

      const sections = navigationItems.map((item) => item.anchor.substring(1));
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (anchor: string) => {
    setIsMenuOpen(false);
    const element = document.querySelector(anchor);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <header data-component-id="src/components/common/Header.tsx:67:4" data-component-path="src/components/common/Header.tsx" data-component-line="67" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-smooth ${
        isScrolled ? 'bg-background shadow-card' : 'bg-background/95 backdrop-blur-sm'
      }`}
    >
      <nav data-component-id="src/components/common/Header.tsx:72:6" data-component-path="src/components/common/Header.tsx" data-component-line="72" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22w-full%20px-4%20md%3Apx-8%20lg%3Apx-16%22%7D" className="w-full px-4 md:px-8 lg:px-16">
        <div data-component-id="src/components/common/Header.tsx:73:8" data-component-path="src/components/common/Header.tsx" data-component-line="73" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-20%22%7D" className="flex items-center justify-between h-20">
          <Link data-component-id="src/components/common/Header.tsx:74:10" data-component-path="src/components/common/Header.tsx" data-component-line="74" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%23inicio%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20group%22%7D"
            href="/#inicio"
            className="flex items-center space-x-3 group"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#inicio');
            }}
          >
            <div data-component-id="src/components/common/Header.tsx:82:12" data-component-path="src/components/common/Header.tsx" data-component-line="82" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-24%20md%3Aw-28%20h-10%20md%3Ah-12%20rounded-lg%20bg-primary%20p-1%20overflow-hidden%20transition-transform%20duration-smooth%20group-hover%3Ascale-105%22%7D" className="flex items-center justify-center w-24 md:w-28 h-10 md:h-12 rounded-lg bg-primary p-1 overflow-hidden transition-transform duration-smooth group-hover:scale-105">
              <AppImage data-component-id="src/components/common/Header.tsx:83:14" data-component-path="src/components/common/Header.tsx" data-component-line="83" data-component-file="Header.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22src%22%3A%22%2Flogo-full-white.png%22%2C%22alt%22%3A%22CGR%20%26%20Asociados%22%2C%22className%22%3A%22w-full%20h-full%20object-contain%22%7D"
                src="/logo-full-white.png"
                alt="CGR & Asociados"
                width={112}
                height={40}
                className="w-full h-full object-contain"
              />
            </div>
            {/* <div className="flex flex-col">
              <span className="text-xl font-bold text-secondary font-headline leading-tight">
                CGR & Asociados
              </span>
              <span className="text-xs text-secondary font-body">
                Corporativo Multidisciplinario
              </span>
            </div> */}
          </Link>

          <div data-component-id="src/components/common/Header.tsx:101:10" data-component-path="src/components/common/Header.tsx" data-component-line="101" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-1%22%7D" className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <a data-component-id="src/components/common/Header.tsx:103:14" data-component-path="src/components/common/Header.tsx" data-component-line="103" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={item.anchor}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className={`px-4 py-2 rounded-md font-body font-medium text-sm transition-all duration-smooth ${
                  activeSection === item.anchor.substring(1)
                    ? 'text-primary bg-accent/20'
                    : 'text-text-secondary hover:text-primary hover:bg-muted'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div data-component-id="src/components/common/Header.tsx:121:10" data-component-path="src/components/common/Header.tsx" data-component-line="121" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20space-x-4%22%7D" className="hidden lg:flex items-center space-x-4">
            <a data-component-id="src/components/common/Header.tsx:122:12" data-component-path="src/components/common/Header.tsx" data-component-line="122" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22tel%3A%2B526699848702%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20px-4%20py-2%20text-primary%20hover%3Atext-primary%2F80%20transition-colors%20duration-smooth%22%7D"
              href="tel:+526699848702"
              className="flex items-center space-x-2 px-4 py-2 text-primary hover:text-primary/80 transition-colors duration-smooth"
            >
              <Icon data-component-id="src/components/common/Header.tsx:126:14" data-component-path="src/components/common/Header.tsx" data-component-line="126" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PhoneIcon%22%7D" name="PhoneIcon" size={20} variant="solid" />
              <span data-component-id="src/components/common/Header.tsx:127:14" data-component-path="src/components/common/Header.tsx" data-component-line="127" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-body%20font-semibold%20text-sm%22%2C%22textContent%22%3A%2266%209984%208702%22%7D" className="font-body font-semibold text-sm">66 9984 8702</span>
            </a>
            <button data-component-id="src/components/common/Header.tsx:129:12" data-component-path="src/components/common/Header.tsx" data-component-line="129" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-6%20py-2.5%20bg-primary%20text-primary-foreground%20rounded-lg%20font-cta%20font-bold%20text-sm%20shadow-cta%20hover%3Abg-primary%2F90%20transition-all%20duration-smooth%20hover%3Ashadow-lg%22%2C%22textContent%22%3A%22Contacto%22%7D"
              onClick={() => handleNavClick('#contacto')}
              className="px-6 py-2.5 bg-primary text-primary-foreground rounded-lg font-cta font-bold text-sm shadow-cta hover:bg-primary/90 transition-all duration-smooth hover:shadow-lg"
            >
              Contacto
            </button>
          </div>

          <button data-component-id="src/components/common/Header.tsx:137:10" data-component-path="src/components/common/Header.tsx" data-component-line="137" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20text-primary%20hover%3Abg-muted%20rounded-lg%20transition-colors%20duration-smooth%22%7D"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-primary hover:bg-muted rounded-lg transition-colors duration-smooth"
            aria-label="Toggle menu"
          >
            <Icon data-component-id="src/components/common/Header.tsx:142:12" data-component-path="src/components/common/Header.tsx" data-component-line="142" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={28} variant="outline" />
          </button>
        </div>
      </nav>

      {isMenuOpen && (
        <div data-component-id="src/components/common/Header.tsx:148:8" data-component-path="src/components/common/Header.tsx" data-component-line="148" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Ahidden%20fixed%20inset-0%20top-20%20bg-background%20z-%5B90%5D%20overflow-y-auto%22%7D" className="lg:hidden fixed inset-0 top-20 bg-background z-[90] overflow-y-auto">
          <div data-component-id="src/components/common/Header.tsx:149:10" data-component-path="src/components/common/Header.tsx" data-component-line="149" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20p-6%20space-y-2%22%7D" className="flex flex-col p-6 space-y-2">
            {navigationItems.map((item) => (
              <a data-component-id="src/components/common/Header.tsx:151:14" data-component-path="src/components/common/Header.tsx" data-component-line="151" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%7D"
                key={item.anchor}
                href={item.anchor}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.anchor);
                }}
                className={`px-4 py-3 rounded-lg font-body font-medium text-base transition-all duration-smooth ${
                  activeSection === item.anchor.substring(1)
                    ? 'text-primary bg-accent/20'
                    : 'text-text-secondary hover:text-primary hover:bg-muted'
                }`}
              >
                {item.label}
              </a>
            ))}

            <div data-component-id="src/components/common/Header.tsx:168:12" data-component-path="src/components/common/Header.tsx" data-component-line="168" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pt-4%20space-y-3%20border-t%20border-border%20mt-4%22%7D" className="pt-4 space-y-3 border-t border-border mt-4">
              <a data-component-id="src/components/common/Header.tsx:169:14" data-component-path="src/components/common/Header.tsx" data-component-line="169" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22tel%3A6699848702%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20space-x-2%20px-4%20py-3%20text-primary%20bg-muted%20rounded-lg%20hover%3Abg-accent%2F20%20transition-colors%20duration-smooth%22%7D"
                href="tel:6699848702"
                className="flex items-center justify-center space-x-2 px-4 py-3 text-primary bg-muted rounded-lg hover:bg-accent/20 transition-colors duration-smooth"
              >
                <Icon data-component-id="src/components/common/Header.tsx:173:16" data-component-path="src/components/common/Header.tsx" data-component-line="173" data-component-file="Header.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PhoneIcon%22%7D" name="PhoneIcon" size={20} variant="solid" />
                <span data-component-id="src/components/common/Header.tsx:174:16" data-component-path="src/components/common/Header.tsx" data-component-line="174" data-component-file="Header.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-body%20font-semibold%22%2C%22textContent%22%3A%22%2B52%2055%201234%205678%22%7D" className="font-body font-semibold">+52 55 1234 5678</span>
              </a>
              <button data-component-id="src/components/common/Header.tsx:176:14" data-component-path="src/components/common/Header.tsx" data-component-line="176" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20px-6%20py-3%20bg-primary%20text-primary-foreground%20rounded-lg%20font-cta%20font-bold%20shadow-cta%20hover%3Abg-primary%2F90%20transition-all%20duration-smooth%22%2C%22textContent%22%3A%22Contacto%22%7D"
                onClick={() => handleNavClick('#contacto')}
                className="w-full px-6 py-3 bg-primary text-primary-foreground rounded-lg font-cta font-bold shadow-cta hover:bg-primary/90 transition-all duration-smooth"
              >
                              Contacto

              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
